import {AfterViewInit, Component, HostListener, Inject, OnDestroy, OnInit, Renderer2} from '@angular/core';
import {
	GuardsCheckStart,
	NavigationCancel,
	NavigationEnd,
	NavigationError,
	NavigationStart, Router, ActivatedRoute
} from '@angular/router';
import { BrowserDetectionService } from './core/browser-detection/browser-detection.service';
import { ContextService } from './core/context/context.service';

import { ScrollHelper } from './shared/helpers/scroll-helper';
// import {enableProdMode} from '@angular/core';
import { authConfig, environment } from '../environments/environment';
import { DomSanitizer } from '@angular/platform-browser';

// RxJs
import { Subject, throwError, Observable } from 'rxjs';
import { catchError, filter, map, skipWhile, takeUntil, tap } from 'rxjs/operators';

import { SecurityService } from '@app/core/security/service/security.service';
import { LoadingService } from '@app/core/loading/loading.service';
import { EventType } from './core/security/service/security.service';

// enableProdMode();

@Component({
	selector: 'pgs-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  
	public isAuthenticated: Observable<boolean>;
  public logoutUrlSanitized: string;

	private ngUnsubscribe: Subject<void>;


	constructor(
    private router: Router,
    private securityService: SecurityService,
    private readonly domSanitizer: DomSanitizer,
    private readonly loadingService: LoadingService,
    private contextService: ContextService,
		private renderer: Renderer2,
		private browserDetectionService: BrowserDetectionService,
	) {
    if (Boolean(sessionStorage.getItem('cypress'))) {
      console.log('windows service injected!');
      window['securityService'] = securityService;
    }
    this.logoutUrlSanitized = this.domSanitizer.bypassSecurityTrustResourceUrl(authConfig.logoutUrl) as string;
	}

  ngOnInit(): void {
    this.ngUnsubscribe = new Subject<void>();

    this.router.events
    .pipe(takeUntil(this.ngUnsubscribe))
    .subscribe(
      e => {
        if (e instanceof NavigationStart) {
          this.renderer.addClass(document.documentElement, 'wait');
        }

        if (e instanceof NavigationEnd
          || e instanceof NavigationCancel
          || e instanceof NavigationError
          || e instanceof GuardsCheckStart) {
          this.renderer.removeClass(document.documentElement, 'wait');
        }

        if (e instanceof NavigationEnd) {
          ScrollHelper.scrollToFirst(undefined, undefined, 'auto');
        }
      }
    );

    // this.contextService.labesLoaded
    // .pipe(takeUntil(this.ngUnsubscribe))
    // .subscribe(value => console.log('luz verde'+ value));

    if (this.browserDetectionService.isIE) {
      this.renderer.addClass(document.documentElement, 'ie');
    }

    this.isAuthenticated = this.securityService.authenticationStatus$.asObservable().pipe(
      map((eventType: string) => eventType === EventType.LOGIN_SUCCESS),
      tap(excelente => console.warn(excelente))
    );
  }

  
	@HostListener('document:click')
	@HostListener('document:keydown')
	// @HostListener('document:wheel')
	private restartLogoutTimeout(): void {
		this.securityService.restartLogoutTimeout();
	}


  get isIframeLogoutVisible(): boolean {
    return this.securityService.showIframeLogout;
  }
  

	ngOnDestroy(): void {
		if (this.ngUnsubscribe) {
			this.ngUnsubscribe.next();
			this.ngUnsubscribe.complete();
		}
	}
}
